var _filter, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "297px",
    height: "94px",
    viewBox: "0 0 296 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 296,
    height: 94,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.992157,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 296,
    height: 94
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,100%,99.607843%)",
      fillOpacity: 1
    },
    d: "M -0.101562 -0.101562 C 10.496094 -0.101562 21.09375 -0.101562 31.691406 -0.101562 C 35.21875 13.226562 38.804688 26.539062 42.457031 39.839844 C 46.042969 26.539062 49.566406 13.226562 53.023438 -0.101562 C 59.929688 -0.101562 66.839844 -0.101562 73.75 -0.101562 C 77.367188 13.265625 80.957031 26.644531 84.515625 40.039062 C 88.097656 26.671875 91.621094 13.292969 95.078125 -0.101562 C 105.742188 -0.101562 116.40625 -0.101562 127.074219 -0.101562 C 121.6875 16.804688 116.085938 33.613281 110.269531 50.328125 C 80.394531 54 50.515625 57.632812 20.625 61.222656 C 20.371094 61.207031 20.136719 61.140625 19.921875 61.019531 C 13.261719 40.820312 6.585938 20.648438 -0.101562 0.503906 C -0.101562 0.300781 -0.101562 0.101562 -0.101562 -0.101562 Z M -0.101562 -0.101562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 296,
    height: 94,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.992157,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 296,
    height: 94
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,100%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 150.816406 -0.101562 C 150.953125 -0.101562 151.085938 -0.101562 151.21875 -0.101562 C 165.425781 31.125 179.714844 62.324219 194.082031 93.496094 C 182.074219 93.765625 170.066406 93.765625 158.0625 93.496094 C 155.679688 88.316406 153.296875 83.140625 150.917969 77.964844 C 148.59375 83.167969 146.214844 88.34375 143.773438 93.496094 C 131.5 93.730469 119.226562 93.765625 106.949219 93.597656 C 121.65625 62.398438 136.277344 31.164062 150.816406 -0.101562 Z M 150.816406 -0.101562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 296,
    height: 94,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.996078,
      stroke: "none"
    }
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 296,
    height: 94
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface11",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,100%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 197.703125 -0.101562 C 206.019531 -0.101562 214.335938 -0.101562 222.652344 -0.101562 C 230.652344 11.828125 238.699219 23.730469 246.800781 35.601562 C 254.902344 23.730469 262.949219 11.828125 270.949219 -0.101562 C 279.265625 -0.101562 287.582031 -0.101562 295.898438 -0.101562 C 295.898438 31.164062 295.898438 62.429688 295.898438 93.699219 C 285.839844 93.699219 275.777344 93.699219 265.714844 93.699219 C 265.75 82.671875 265.714844 71.644531 265.613281 60.617188 C 259.378906 69.828125 253.140625 79.039062 246.902344 88.25 C 240.449219 79.027344 234.078125 69.75 227.785156 60.414062 C 227.683594 71.507812 227.648438 82.601562 227.683594 93.699219 C 217.691406 93.699219 207.695312 93.699219 197.703125 93.699219 C 197.703125 62.429688 197.703125 31.164062 197.703125 -0.101562 Z M 197.703125 -0.101562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 296,
    height: 94,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.972549,
      stroke: "none"
    }
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 296,
    height: 94
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface14",
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,100%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 96.890625 54.160156 C 101.386719 54.007812 104.238281 56.09375 105.441406 60.414062 C 106.042969 65.300781 103.996094 68.425781 99.304688 69.792969 C 94.390625 70.308594 91.273438 68.191406 89.945312 63.441406 C 89.652344 58.328125 91.96875 55.234375 96.890625 54.160156 Z M 96.890625 54.160156 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 296,
    height: 94,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.972549,
      stroke: "none"
    }
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 296,
    height: 94
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface17",
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,100%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 64.492188 57.992188 C 69.816406 58.085938 72.765625 60.773438 73.347656 66.0625 C 73.101562 69.902344 71.15625 72.425781 67.511719 73.625 C 63.464844 74.40625 60.414062 73.027344 58.355469 69.492188 C 56.757812 65.082031 57.863281 61.554688 61.675781 58.902344 C 62.632812 58.570312 63.570312 58.265625 64.492188 57.992188 Z M 64.492188 57.992188 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 296,
    height: 94,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.972549,
      stroke: "none"
    }
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 296,
    height: 94
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface20",
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,100%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 30.6875 62.027344 C 35.6875 61.632812 38.808594 63.851562 40.042969 68.683594 C 40.335938 73.5 38.15625 76.492188 33.503906 77.660156 C 27.929688 77.859375 24.84375 75.167969 24.246094 69.59375 C 24.800781 65.644531 26.949219 63.125 30.6875 62.027344 Z M 30.6875 62.027344 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 296,
    height: 94,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.988235,
      stroke: "none"
    }
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 296,
    height: 94
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface23",
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,100%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 102.320312 72.316406 C 102.589844 72.316406 102.859375 72.316406 103.128906 72.316406 C 101.011719 79.421875 98.730469 86.480469 96.285156 93.496094 C 74.417969 93.730469 52.554688 93.765625 30.6875 93.597656 C 29.214844 89.609375 27.941406 85.609375 26.863281 81.59375 C 52.042969 78.515625 77.195312 75.421875 102.320312 72.316406 Z M 102.320312 72.316406 "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface11",
    mask: "url(#mask2)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface14",
    mask: "url(#mask3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface17",
    mask: "url(#mask4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface20",
    mask: "url(#mask5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface23",
    mask: "url(#mask6)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWam);
export default __webpack_public_path__ + "static/media/wam.a40a0beaf71046389ba74d4e67d2bb99.svg";
export { ForwardRef as ReactComponent };